import { Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { format } from "react-string-format"

const TextInput = (props: any) => {
    const [t] = useTranslation()

    return (
        <Controller
            name={props.name}
            control={props.control}
            rules={props?.rules}
            render={({
                field: { onChange, value },
                fieldState: { error },
                formState
            }) =>
                <div
                    className={`group form-floating w-full relative ${((props.errors) ? " validation-error" : "")}`}>
                    <input
                        {...props}
                        // اضافه کردن کلاس CSS برای اینکه در لحظه تایپ هم حروف بزرگ دیده شوند
                        className={`form-text transition-all ${(props.unitText ? "pl-11 peer" : "peer")} ${props.uppercase ? "uppercase" : ""}`}
                        value={value}
                        onChange={(e) => {
                            const val = e.target.value;
                            // اگر پراپ uppercase وجود داشت، مقدار را بزرگ کن در غیر این صورت همان را بفرست
                            onChange(props.uppercase ? val.toUpperCase() : val);
                        }}
                        autoComplete="off"
                        placeholder="" />

                    <label htmlFor={props.id} className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3">
                        <span className="relative">
                            {props.label}
                            {props.rules?.required && <span style={{ color: "#d84b4b" }}>*</span>}
                        </span>
                    </label>

                    {props.unitText && <div className="absolute left-3 top-3.5">{props.unitText}</div>}

                    {/* بخش نمایش خطاها */}
                    {props.errors && props.errors.type as any === 'required' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message : format(t('VALIDATION_ERROR_REQUIRED'), props.label)}
                        </div>
                    }

                    {props.errors && props.errors.type as any == 'minLength' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                (props.rules?.maxLength == undefined || props.rules?.minLength == props.rules?.maxLength ?
                                    format(t('VALIDATION_ERROR_EXACT_STRING_LENGTH'), props.label, props.rules?.minLength)
                                    :
                                    format(t('VALIDATION_ERROR_STRING_LENGTH'), props.label, props.rules?.minLength, props.rules?.maxLength))}
                        </div>
                    }

                    {props.errors && props.errors.type as any == 'maxLength' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                (props.rules?.minLength == undefined || props.rules?.minLength == props.rules?.maxLength ?
                                    format(t('VALIDATION_ERROR_EXACT_STRING_LENGTH'), props.label, props.rules?.maxLength)
                                    :
                                    format(t('VALIDATION_ERROR_MAX_STRING_LENGTH'), props.label, props.rules?.minLength, props.rules?.maxLength))}
                        </div>
                    }

                    {props.errors && props.errors.type as any == 'validate' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                format(t('VALIDATION_ERROR_INVALID'), props.label)}
                        </div>
                    }
                </div>
            }
        />
    )
}

export default TextInput